module.exports = __webpack_public_path__ + "img/arrow-right.cd06da85.svg";